import { BotId, EnvironmentType, IntentId, NlpModelId } from '@feedyou-ai/feedbot-schema'

import { RootState } from '../../reducers'
import { nlpIntentSelector, nlpModelByIdSelector } from '../botNlp/selectors'
import { environmentGroupForCurrentBotSelector } from '../../features/serverBots/selectors/environmentGroupForCurrentBotSelector'

export function nlpEditorSearchValueSelector(state: RootState): string {
  return state.nlpEditor.searchValue
}

export const dialogIdForIntentSelector =
  (modelId: NlpModelId, intentId: IntentId) => (state: RootState) => {
    const intent = nlpIntentSelector(modelId, intentId)(state)
    const model = nlpModelByIdSelector(modelId)(state)

    return intent?.dialog || model?.defaultDialog
  }

export function isIntentExpandedForIdSelector(state: RootState, intentId: string): boolean {
  return state.nlpEditor.isIntentExpandedForId[intentId] || false
}

export function sourceEnvironmentForTrainingSelector(state: RootState): EnvironmentType {
  return state.nlpEditor.sourceEnvironmentForTraining
}

export function trainingSourceBotIdSelector(state: RootState): BotId {
  const targetEnvironment = sourceEnvironmentForTrainingSelector(state)
  const environmentGroup = environmentGroupForCurrentBotSelector(state)
  // @ts-ignore
  return targetEnvironment === 'prod' ? environmentGroup.prodId : environmentGroup.testId
}
